import { BigNumberish, BigNumber } from 'ethers'
import { Synth } from 'src/services/GraphService'

import { BASE } from '../constants/crypto'
import { eqIgnoreCase } from '@arcxmoney/arcx-core'

export enum Status {
  invalid = '#FF7171',
  danger = '#FFB571',
  risk = '#d1b219',
  safe = '#55FF99',
  none = 'grey',
}

export function getStatusString(status: Status): string {
  switch (status) {
    case Status.invalid:
      return 'invalid'
    case Status.danger:
      return 'danger'
    case Status.risk:
      return 'risk'
    case Status.safe:
      return 'safe'
    case Status.none:
      return '-'
  }
}

export function getCollateralStatus(
  volatileCollaterals: string[],
  synth: Synth,
  collateralRatio: BigNumberish,
): Status {
  if (!collateralRatio || !synth) {
    return Status.none
  }
  if (collateralRatio === 0) {
    return Status.invalid
  }
  const isVolatileCollateral = volatileCollaterals.find((volatile) =>
    eqIgnoreCase(volatile, synth.collateral),
  )
  const minimumRatio = synth.collateralRatio.mul(isVolatileCollateral ? 100 : 100).div(BASE)

  const riskRatio = BigNumber.from(minimumRatio)
    .mul(isVolatileCollateral ? 125 : 105)
    .div(100)

  if (BigNumber.from(collateralRatio).gte(riskRatio)) {
    return Status.safe
  }
  if (BigNumber.from(collateralRatio).gt(minimumRatio)) {
    return Status.risk
  }
  if (BigNumber.from(collateralRatio).gt(0)) {
    return Status.danger
  }
  return Status.invalid
}
